import _JSXStyle from "styled-jsx/style";
import { colors, spacers } from '@dhis2/ui-constants';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const translate = (prop, interpolationObject) => {
  if (typeof prop === 'function') {
    return prop(interpolationObject);
  }

  return prop;
};

const PageSummary = _ref => {
  let {
    dataTest,
    firstItem,
    inactive,
    lastItem,
    page,
    pageCount,
    pageSummaryText,
    total
  } = _ref;
  const summary = translate(pageSummaryText, {
    firstItem,
    lastItem,
    page,
    pageCount,
    total
  });
  return /*#__PURE__*/React.createElement("div", {
    "data-test": "".concat(dataTest, "-summary"),
    className: _JSXStyle.dynamic([["3973865131", [spacers.dp12, colors.grey700, colors.grey500]]])
  }, /*#__PURE__*/React.createElement("span", {
    className: _JSXStyle.dynamic([["3973865131", [spacers.dp12, colors.grey700, colors.grey500]]]) + " " + (cx({
      inactive
    }) || "")
  }, summary), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3973865131",
    dynamic: [spacers.dp12, colors.grey700, colors.grey500]
  }, ["div.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;min-height:32px;margin-inline-end:".concat(spacers.dp12, ";}"), "span.__jsx-style-dynamic-selector{color:".concat(colors.grey700, ";font-size:14px;}"), "span.inactive.__jsx-style-dynamic-selector{color:".concat(colors.grey500, ";}")]));
};

PageSummary.propTypes = {
  dataTest: PropTypes.string.isRequired,
  page: PropTypes.number.isRequired,
  pageSummaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  firstItem: PropTypes.number,
  inactive: PropTypes.bool,
  lastItem: PropTypes.number,
  pageCount: PropTypes.number,
  total: PropTypes.number
};
export { PageSummary };